import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CashInRequest } from '@cash-web/shared-util-protos/squareup/moneta/api/CashInRequestProto.pb'
import { CashInResponse } from '@cash-web/shared-util-protos/squareup/moneta/api/CashInResponseProto.pb'

export const cashIn = (request: CashInRequest, options?: CashRequestOptions) =>
  post<CashInRequest, CashInResponse>('/2.0/cash/cash-in', request, { ...options, rejectOnError: true })
